export default window._cmsContent['solar/extra-info']